import React from "react";
import { FaFacebook, FaInstagram, FaYoutube } from "react-icons/fa";

const Footer = () => {
  return (
    <div>
      <footer style={styles.footer}>
        {/* Footer Top */}
        <div style={styles.footerTop}>
          <div style={styles.logoContainer}>
            <a href="index.html">
              <img
                src="assets/images/logo3.png"
                alt="Logo"
                style={styles.logo}
              />
            </a>
            <p style={styles.slogan}>Captures Every Moment of Your Life.</p>
            <div style={styles.socialLinks}>
              <a href="https://www.facebook.com/share/12K28RAsrah/?mibextid=wwXIfr" style={styles.socialIcon}><FaFacebook size={24} /></a>
              <a href="https://www.instagram.com/romiyography?igsh=MXc0amZ6MW1yazE3Mg==" style={styles.socialIcon}><FaInstagram size={24} /></a>
              <a href="https://youtube.com/@romiyography?si=GDxHP6ZiOFpbHFLw" style={styles.socialIcon}><FaYoutube size={24} /></a>
            </div>
          </div>

          {/* Quick Links Column */}
          <div style={styles.column}>
            <h4 style={styles.columnTitle}>Quick Links</h4>
            <ul style={styles.list}>
              <li><a href="/" style={styles.link}>Home</a></li>
              <li><a href="/about" style={styles.link}>About</a></li>
              <li><a href="/calculator" style={styles.link}>Pricing</a></li>
              <li><a href="/contact" style={styles.link}>Contact</a></li>
            </ul>
          </div>

          {/* Services Column */}
          <div style={styles.column}>
            <h4 style={styles.columnTitle}>Services</h4>
            <ul style={styles.list}>
              <li><a href="" style={styles.link}>Premium Pre Wedding</a></li>
              <li><a href="" style={styles.link}>Premium Wedding</a></li>
              <li><a href="" style={styles.link}>Cinematic Film's</a></li>
              <li><a href="" style={styles.link}>Model Portfolio</a></li>
              <li><a href="" style={styles.link}>All Types of Events</a></li>
            </ul>
          </div>
        </div>

        {/* Footer Bottom */}
        <div style={styles.footerBottom}>
          <p style={styles.footerText}>© Romesh Bhakte Films || All rights reserved</p>
        </div>
      </footer>
    </div>
  );
};

// Styles for the Footer
const styles = {
  footer: {
    backgroundColor: "#000", // Changed to black
    color: "white",
    padding: "40px 20px",
  },
  footerTop: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "30px",
    flexWrap: "wrap", // Ensures elements wrap to the next line on smaller screens
    gap: "20px", // Add space between columns on mobile
  },
  logoContainer: {
    flex: 1,
    textAlign: "center", // Center the logo container content
    marginBottom: "20px", // Add spacing below the logo container for mobile
  },
  logo: {
    width: "300px",
    height:"80px",
    marginBottom: "15px",
    display:"inline"
  },
  slogan: {
    fontSize: "16px",
    marginBottom: "20px",
    fontStyle: "italic",
  },
  socialLinks: {
    display: "flex",
    gap: "15px", // Added gap between icons
    marginTop: "15px",
    justifyContent: "center", // Center social links
  },
  socialIcon: {
    color: "white",
    textDecoration: "none",
  },
  column: {
    flex: 1,
    margin: "0 20px",
    minWidth: "250px", // Ensures columns don't get too small
    textAlign: "center", // Center align all content in columns
  },
  columnTitle: {
    fontSize: "18px",
    fontWeight: "bold",
    marginBottom: "15px",
  },
  list: {
    listStyle: "none",
    padding: 0,
  },
  link: {
    color: "white",
    textDecoration: "none",
    marginBottom: "10px",
    display: "block",
    fontSize: "16px",
  },
  footerBottom: {
    textAlign: "center",
    borderTop: "1px solid #34495E",
    paddingTop: "15px",
    marginTop: "20px",
  },
  footerText: {
    fontSize: "14px",
  },

  // Mobile responsiveness - Stack footer columns one below another for screens below 768px
  "@media (max-width: 768px)": {
    footerTop: {
      flexDirection: "column", // Stack columns vertically for mobile
      alignItems: "center", // Center align all content
    },
    column: {
      marginBottom: "20px", // Add margin between stacked columns
      minWidth: "unset", // Remove min-width for stacking
      textAlign: "center", // Center the text in the columns
    },
    socialLinks: {
      justifyContent: "center", // Center the social links
      gap: "15px", // Maintain gap for social icons
    },
    footerBottom: {
      paddingTop: "20px",
    },
    logoContainer: {
      marginBottom: "30px", // Ensure space below logo on mobile
    },
  },
};

export default Footer;
